import { ProductCategories } from '../types';
import { create } from 'zustand';
import { env } from 'process';

export interface StoreState {
  categoryData: ProductCategories[] | null;
}

export type NavigationStore = StoreState & StoreActions;

export interface StoreActions {
  getCategoryData: () => Promise<void>;
}

const initState: StoreState = {
  categoryData: null,
};

export const asyncNavStore = create<NavigationStore>()((set, get) => ({
  ...initState,

  getCategoryData: async () => {
    const isDev = process.env.NODE_ENV === 'development';
    const cacheTime = isDev
      ? 5
      : env?.CACHE_TIMING
        ? Number(env.CACHE_TIMING)
        : 3600;

    const response = await fetch('/api/nav', {
        next: { revalidate: cacheTime },
      }),
      jsonData = (await response.json()) as ProductCategories[];

    set({ categoryData: jsonData });
  },
}));
